import { z } from 'zod';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;

/** Champ libre du filleul : une adresse email ou un numéro de téléphone. */
export const isParrainageEmail = (value: string) => EMAIL_PATTERN.test(value);
export const isParrainagePhone = (value: string) => PHONE_PATTERN.test(value);

/** Numéro saisi (espaces, points, +33…) ramené aux 10 chiffres envoyés jusqu'ici. */
export const normalizeParrainagePhone = (value: string) =>
    value.replace(/[\s.-]/g, '').replace(/^(?:\+|00)33/, '0');

export interface SendParrainageValues {
    text?: string;
    email: string;
    phone: string;
    index?: unknown;
}

/** Invitation de parrainage : email ou téléphone du filleul obligatoire et valide. */
export const sendParrainageSchema = z.looseObject({}).superRefine((values, ctx) => {
    const text = (values as Record<string, unknown>)['text'] as string | undefined;

    if (!text) {
        ctx.addIssue({ code: 'custom', path: ['text'], message: 'Ce champ est obligatoire' });
    } else if (!isParrainageEmail(text) && !isParrainagePhone(text)) {
        ctx.addIssue({ code: 'custom', path: ['text'], message: 'Veuillez entrer un email ou un numéro de téléphone valide' });
    }
});
